import * as packageActions from '../../../actions/Packages';

export function updateFieldsHiddenStatus(screen, packagesIds?) {
    packageActions.updateFieldsHiddenStatus(screen.parentScreen.screens[0].collection, packagesIds);
    packageActions.updateFieldsHiddenStatus(screen.parentScreen.screens[1].collection, packagesIds);
}
